function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 10"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.697 11.73L4.21 10.487c-1.246-.645-1.96-1.46-1.96-2.237A2.753 2.753 0 015 5.5a3.88 3.88 0 012.98 1.513 1 1 0 101.54-1.276A5.99 5.99 0 006 3.592V2a1 1 0 00-2 0v1.606A4.758 4.758 0 00.25 8.25c0 1.573 1.08 2.998 3.053 4.02l2.487 1.243c1.246.645 1.96 1.46 1.96 2.237A2.753 2.753 0 015 18.5a3.88 3.88 0 01-2.98-1.513 1 1 0 10-1.54 1.276A5.99 5.99 0 004 20.408V22a1 1 0 002 0v-1.606a4.758 4.758 0 003.75-4.644c0-1.573-1.08-2.998-3.053-4.02zM13 8h7.586l-1.793 1.793a1 1 0 101.414 1.414l3.5-3.5a1 1 0 000-1.414l-3.5-3.5a1 1 0 00-1.414 1.414L20.586 6H13a1 1 0 000 2zM23 16h-7.586l1.793-1.793a1 1 0 00-1.414-1.414l-3.5 3.5a1 1 0 000 1.414l3.5 3.5a1 1 0 001.414-1.414L15.414 18H23a1 1 0 000-2z"
})));